<template>
  <li>
    <a-button
      className="anz-link anz-fs-xss anz-color-black-30"
      @click="onclick"
      :class="{ 'anz-color-default': active }"
    >
      <template #title>
        <slot name="title"> {{ title }}</slot>
        {{ ' (' + count + ')' }}
      </template>
    </a-button>
  </li>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'

export default defineComponent({
  name: 'ProfileSubMenuItem',
  components: { AButton },
  emits: ['click'],
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onclick(event: any) {
      if (!this.disabled) {
        this.$emit('click', event)
      }
    },
  },
})
</script>
